export default "Launch the poll before speaking. \"Same question — which image is more blurry? Take a look and vote.\" Pause ~15 seconds while students vote.\n"